/* ============================================================
   SIDRENA CIJENA NA PDP-u (apifood-hero-pp forma), 28.9.2026.
   ------------------------------------------------------------
   Gdje se prikazuje:
     - proizvod s pretplatom (Loop widget "Opcije kupovine" vidljiv):
       ispod cijene u SVAKOJ opciji (Jednokratna kupnja / Preplati se)
     - proizvod bez pretplate: ispod gumba "Dodaj u kosaricu"
   Podaci su isti kao u appu "sidrena-cijena-apipet": /apps/cjenik/sidrene.json
   (endpoint se cita s app skripte sidrena-svugdje.js), po odabranoj
   varijanti (input name="id" u formi).
     - redak "Cijena <datum>: X €" uvijek
     - redak "Najniza cijena u zadnjih 30 dana" kad je cijena snizena:
       opcija prikazuje prekrizenu cijenu (pretplata) ILI je varijanta
       jeftinija od sidrene (npr. 120 kapsula -12%)
   Zasto ne appov PDP redak: app ga stavi uz "najdublju" cijenu na
   stranici, a to ovisi o tome je li Loop widget stigao prije appa - zna
   zavrsiti u gumbu, u Loop opciji ili u SKRIVENOM Loop widgetu (proizvodi
   bez pretplate -> sidrena se ne vidi). Zato ga forma s klasom
   .ap-sidrena-vlastita skriva (assets/apipet-sidrena.css), a ova skripta
   crta svoj redak na tocno odredjenom mjestu.
   Greska u dohvatu ili varijanta bez zapisa: klasa se ne stavlja, vrijedi
   appov prikaz.
   Revert = makni <script> za ovaj file iz snippets/meta-tags.liquid.
   ============================================================ */
(function () {
  var BLOK = 'ap-sidrena-blok';
  var zakazano = false;
  var mapa = null;
  var ucitavanje = null;

  function endpoint() {
    var s = document.querySelector('script[src*="sidrena-svugdje"][data-endpoint]');
    return s ? s.dataset.endpoint : null;
  }

  function ucitaj() {
    if (mapa || ucitavanje) return;
    var url = endpoint();
    if (!url) return;
    ucitavanje = fetch(url)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (j && j.aktivno && j.cijene) { mapa = j; zakazi(); }
      })
      .catch(function () {})
      .then(function () { ucitavanje = null; });
  }

  function iznos(x) {
    return parseInt(String(x || '').replace(/[^0-9]/g, ''), 10) || 0;
  }

  function vidljiv(el) {
    return !!el && el.getClientRects().length > 0;
  }

  function redak(oznaka, vrijednost, najniza) {
    var d = document.createElement('div');
    d.className = 'sc-sidrena ap-sidrena' + (najniza ? ' ap-sidrena--najniza' : '');
    var l = document.createElement('span');
    l.className = 'sc-sidrena__label';
    l.textContent = oznaka + ':';
    var v = document.createElement('span');
    v.className = 'sc-sidrena__value';
    v.textContent = vrijednost;
    d.appendChild(l);
    d.appendChild(v);
    return d;
  }

  /** Blok s retcima odmah iza elementa `iza`; prepisuje se samo kad se sadrzaj promijeni. */
  function postavi(blok, iza, klasa, oznaka, zapis, najniza) {
    if (!blok) {
      blok = document.createElement('div');
      blok.className = klasa;
    }
    if (blok.previousElementSibling !== iza) iza.insertAdjacentElement('afterend', blok);
    var kljuc = [oznaka, zapis.c, najniza ? zapis.n : ''].join('|');
    if (blok.getAttribute('data-k') !== kljuc) {
      blok.setAttribute('data-k', kljuc);
      blok.textContent = '';
      blok.appendChild(redak(oznaka, zapis.c, false));
      if (najniza) {
        blok.appendChild(redak(mapa.oznakaNajniza || 'Najniža cijena u zadnjih 30 dana', zapis.n, true));
      }
    }
  }

  function sync() {
    zakazano = false;
    var forme = document.querySelectorAll('form.api-product-form');
    if (!forme.length) return;
    if (!mapa) ucitaj();

    for (var i = 0; i < forme.length; i++) {
      var f = forme[i];
      var polje = f.querySelector('[name="id"]');
      var zapis = mapa && polje ? mapa.cijene[polje.value] : null;
      var gumb = f.querySelector('.apipet-btn-primary');
      var opcije = f.querySelectorAll('.loop-widget-purchase-option');
      var uLoopu = [].some.call(opcije, vidljiv);
      var ok = !!(zapis && zapis.c && (uLoopu || gumb));

      if (f.classList.contains('ap-sidrena-vlastita') !== ok) {
        f.classList.toggle('ap-sidrena-vlastita', ok);
      }

      var oznaka = ok ? (zapis.o || mapa.oznaka || '') : '';
      var snizenaVarijanta = ok && iznos(zapis.t) < iznos(zapis.c);

      // 1) opcije kupovine (pretplata)
      for (var j = 0; j < opcije.length; j++) {
        var opcija = opcije[j];
        var glava = opcija.querySelector(':scope > .loop-widget-purchase-option-header');
        var blok = opcija.querySelector(':scope > .' + BLOK);
        if (!ok || !uLoopu || !glava) { if (blok) blok.remove(); continue; }
        var prekrizena = opcija.querySelector('.loop-widget-purchase-option-compare-at-price');
        var najniza = (vidljiv(prekrizena) || snizenaVarijanta) && zapis.n;
        postavi(blok, glava, BLOK, oznaka, zapis, najniza);
      }

      // 2) ispod gumba (bez pretplate)
      var gBlok = f.querySelector('.' + BLOK + '--gumb');
      if (!ok || uLoopu || !gumb) {
        if (gBlok) gBlok.remove();
      } else {
        postavi(gBlok, gumb, BLOK + ' ' + BLOK + '--gumb', oznaka, zapis, snizenaVarijanta && zapis.n);
      }
    }
  }

  function zakazi() {
    if (zakazano) return;
    zakazano = true;
    if (window.requestAnimationFrame) requestAnimationFrame(sync); else setTimeout(sync, 16);
  }

  function pokreni() {
    sync();
    if (!window.MutationObserver) return;
    new MutationObserver(function (promjene) {
      for (var i = 0; i < promjene.length; i++) {
        var t = promjene[i].target;
        var el = t.nodeType === 1 ? t : t.parentElement;
        // vlastite izmjene ne pokrecu novi krug
        if (el && el.closest && el.closest('.' + BLOK)) continue;
        // od promjena klase/stila zanima nas samo Loop widget
        if (promjene[i].type === 'attributes' &&
            String((el && el.className) || '').indexOf('loop-widget') === -1) continue;
        zakazi();
        return;
      }
    }).observe(document.body, {
      childList: true, subtree: true, characterData: true,
      // Loop skriva/prikazuje widget i prekrizenu cijenu klasom loop-display-none
      attributes: true, attributeFilter: ['class', 'style']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pokreni);
  } else {
    pokreni();
  }
})();